import { syncQueue } from "./sync"
import { showPwaFlash } from "./show_pwa_flash"

// Register Service Worker
if ("serviceWorker" in navigator) {
    navigator.serviceWorker
        .register("/service-worker.js")
        .then(reg => {
            console.log("Service Worker registered:", reg.scope)
        })
        .catch(err => {
            console.error("SW registration failed:", err)
        })
}

// Sync when back online
window.addEventListener("online", () => {
    syncQueue()
    showPwaFlash("オンラインに戻りました。同期します。", "success")
})

window.addEventListener("offline", () => {
    showPwaFlash("オフラインです。同期はバックグラウンドで行われます。", "error")
})

document.addEventListener("DOMContentLoaded", () => {
    if (navigator.onLine) {
        syncQueue()
    }
})